/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Launcher_TitleInputs */

const en_fc_dl_launcher_title = /** @type {(inputs: Fc_Dl_Launcher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easiest: ArtCraft Launcher`)
};

/**
* | output |
* | --- |
* | "Easiest: ArtCraft Launcher" |
*
* @param {Fc_Dl_Launcher_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_launcher_title = /** @type {((inputs?: Fc_Dl_Launcher_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Launcher_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_launcher_title(inputs)
});
export { fc_dl_launcher_title as "fc.dl.launcher.title" }